(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-free-shipping-progress-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sf-shipping-progress')) {
  const CART_WRITES = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  const CART_EVENTS = ['cart:updated', 'cart:refresh', 'cart:change'];

  class SfShippingProgress extends HTMLElement {
    static watchCart() {
      if (window.__sfCartWatch || typeof window.fetch !== 'function') return;
      window.__sfCartWatch = true;
      const originalFetch = window.fetch;
      window.fetch = function (...args) {
        const result = originalFetch.apply(window, args);
        const target = args[0];
        const url = String(target && target.url ? target.url : target);
        if (CART_WRITES.some((path) => url.includes(path))) {
          result
            .then(() => document.querySelectorAll('sf-shipping-progress').forEach((el) => el.refresh()))
            .catch(() => {});
        }
        return result;
      };
    }

    connectedCallback() {
      SfShippingProgress.watchCart();
      this.onCartEvent = () => this.refresh();
      CART_EVENTS.forEach((type) => document.addEventListener(type, this.onCartEvent));
    }

    disconnectedCallback() {
      CART_EVENTS.forEach((type) => document.removeEventListener(type, this.onCartEvent));
    }

    async refresh() {
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        this.update(await response.json());
      } catch (error) {
        // Network errors leave the last rendered state in place.
      }
    }

    update(cart) {
      const threshold = Number(this.dataset.threshold);
      if (!threshold || !cart || cart.currency !== this.dataset.currency) return;
      const remaining = Math.max(0, threshold - cart.total_price);
      const percent = Math.min(100, Math.floor((cart.total_price * 100) / threshold));
      const message = this.querySelector('.sf-ship__message');
      if (message) {
        message.textContent = remaining > 0
          ? this.dataset.progress.split('[amount]').join(this.format(remaining))
          : this.dataset.success;
      }
      const bar = this.querySelector('.sf-ship__bar');
      const fill = this.querySelector('.sf-ship__fill');
      if (bar) bar.setAttribute('aria-valuenow', String(percent));
      if (fill) fill.style.width = percent + '%';
    }

    format(cents) {
      const pattern = this.dataset.moneyFormat || '';
      const match = pattern.match(new RegExp('\\u007b\\u007b\\s*(\\w+)\\s*\\u007d\\u007d'));
      if (match) {
        const group = (n, sep) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        const value = cents / 100;
        const whole = group(Math.round(value), match[1].includes('comma') ? '.' : ',');
        const fixed = Math.abs(value).toFixed(2);
        let amount = null;
        if (match[1] === 'amount') amount = group(fixed.split('.')[0], ',') + '.' + fixed.split('.')[1];
        else if (match[1] === 'amount_no_decimals') amount = whole;
        else if (match[1] === 'amount_with_comma_separator') amount = group(fixed.split('.')[0], '.') + ',' + fixed.split('.')[1];
        else if (match[1] === 'amount_no_decimals_with_comma_separator') amount = whole;
        if (amount !== null) return pattern.replace(match[0], amount).replace(/<[^>]*>/g, '');
      }
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: this.dataset.currency,
        }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2);
      }
    }
  }
  customElements.define('sf-shipping-progress', SfShippingProgress);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var video = document.querySelector('#VideoHero-{{ section.id }} video');
    if (!video) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
